module.exports = __webpack_public_path__ + "img/05.487a40af.png";